import Footer from './components/Footer';
import Home from './components/Home/Home';
import Navs from './components/Navs/Navs';


function App() {
  return (
    <>
    <Navs />
    <Home />
    <Footer />
    </>
  );
}

export default App;
